import * as React from 'react';
import { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Grid, Box, Chip } from '@mui/material';
import { useNotify } from 'react-admin';
import { getAccessToken } from '../authProvider';
import { API_BASE_URL } from '../config';
import { AiVideoStatistics, AI_STATUS_MAP } from './types';

const AiVideoStats = () => {
    const [stats, setStats] = useState<AiVideoStatistics>({});
    const [loading, setLoading] = useState(true);
    const notify = useNotify();

    useEffect(() => {
        const fetchStats = async () => {
            try {
                setLoading(true);
                const token = await getAccessToken();
                if (!token) {
                    notify('Authentication required', { type: 'error' });
                    return;
                }
                const response = await fetch(`${API_BASE_URL}/api/admin/aiVideoStatistics`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });
                const result = await response.json();
                if (result.code === 200) {
                    setStats(result.data || {});
                } else {
                    notify('Error loading statistics', { type: 'error' });
                }
            } catch (error) {
                notify('Error loading statistics', { type: 'error' });
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, [notify]);

    const getStatusColor = (status: string): 'default' | 'primary' | 'error' | 'success' => {
        switch (status) {
            case '0': return 'default';
            case '1': return 'primary';
            case '2': return 'error';
            case '9': return 'success';
            default: return 'default';
        }
    };

    if (loading) {
        return (
            <Card sx={{ mb: 2 }}>
                <CardContent>
                    <Typography variant="h6">Loading statistics...</Typography>
                </CardContent>
            </Card>
        );
    }

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    AI Video Analysis Statistics
                </Typography>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    {Object.entries(stats).map(([status, count]) => (
                        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={status}>
                            <Box
                                sx={{
                                    p: 2,
                                    border: 1,
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    textAlign: 'center',
                                }}
                            >
                                <Chip 
                                    label={AI_STATUS_MAP[parseInt(status)] || `Status ${status}`}
                                    color={getStatusColor(status)}
                                    sx={{ mb: 1 }}
                                />
                                <Typography variant="h4" color="primary">
                                    {count}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    videos
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default AiVideoStats;
